module.exports = __webpack_public_path__ + "static/media/Illustration2.dfb2ea3c.png";